// extracted by mini-css-extract-plugin
export default {"tooltip":"hT-z","arrow":"iT-z"};